var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Component != null)?_c(_vm.Component,{tag:"component",attrs:{"Arguments":_vm.Arguments,"Enabled":_vm.FinalEnabled,"value":_vm.value},on:{"input":_vm.OnInput,"change":_vm.OnChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }